import ApiService from '../../../../../services/ApiService'
import ManageAlert from '../../../Alert/components/manageAlert/ManageAlert.vue'
import Utils from '../../../../../Utils/FormatDate'

export default {
  props: {
    title: String,
    externalFile: Object,
  },

  components: {
    ManageAlert,
  },

  created() {
    if (this.externalFile) {
      this.currentExternalFile = this.externalFile
      this.expiredDateTime = this.externalFile.expiredDate
      this.isEditing = true
    }
  },

  data: () => ({
    step: 0,
    selectedTab: 0,
    tab: null,
    errorMessage: '',
    menuExpiredDate: false,
    loading: false,
    firstValid: true,
    changedData: false,
    isEditing: false,
    error: false,
    alterDialog: false,
    alertDialog: false,
    expiredDateTimeError: false,
    dialogKey: false,
    expiredDateTime: null,
    alert: {},
    currentExternalFile: {
      id: 0,
      name: '',
      url: '',
      expiredDate: null,
      description: '',
    },
    nameRules: [
      (v) => !!v || 'Nome requerido',
      (v) => (v && v.length <= 128) || 'Nome deve ter no máximo 128 caracteres',
    ],
    descriptionRules: [
      (v) => !!v || 'Descrição requerida',
      (v) =>
        (v && v.length <= 400) || 'Descrição deve ter no máximo 400 caracteres',
    ],
    urlRules: [
      (v) => !!v || 'URL requerida',
      (v) =>
        /https?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(v) ||
        'URL inválida',
    ],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      if (this.alertDialog) {
        this.alertDialog = false
      } else {
        this.changedData = false
        this.close()
      }
    },

    setExpiredNowDate() {
      this.expiredDateTime = !this.expiredDateTime
        ? new Date()
        : this.expiredDateTime
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate() && this.expiredDateTime) {
          this.submit()
        } else {
          this.expiredDateTimeError = true
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      const externalFileControl = {
        Id: this.currentExternalFile.id,
        Name: this.currentExternalFile.name,
        Url: this.currentExternalFile.url,
        ExpiredDate: Utils.nowDatetimeFormat(this.expiredDateTime),
        Description: this.currentExternalFile.description,
      }

      let url = 'externalFileControl/add'

      if (this.isEditing) {
        url = 'externalFileControl/edit'
      }

      await this.apiService
        .post(url, externalFileControl)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )}T${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
  },

  watch: {
    currentExternalFile: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    expiredDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.expiredDateTimeError = false
      },
    },
  },
}
